// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"647":"0ff7c46caaed4d05","792":"48ec110f9fb5a3f7","907":"2a40e62e4f5dd834"}[chunkId] + ".js";
};